import React, { useMemo } from "react";
import classes from "./style.module.scss";
import PropTypes from "prop-types";

// Cognito auto-generated fields — not useful for display
const IGNORED_FIELDS = ['Id', 'ItemNumber'];

const formatHeader = (key) => key.replace(/([a-z])([A-Z])/g, '$1 $2');

export const ApplicationFormTable = ({ style, columnsNamesAndFields, data }) => {
  const columns = useMemo(() => {
    if (columnsNamesAndFields) {
      return Object.entries(columnsNamesAndFields).map(([header, field]) => ({ header, field }));
    }

    if (!data?.length) return [];

    const keys = [...new Set(data.flatMap(Object.keys))].filter(k => !IGNORED_FIELDS.includes(k));
    return keys.map(key => ({ header: formatHeader(key), field: key }));
  }, [columnsNamesAndFields, data]);

  return (
    <table className={classes.ApplicationFormTable} style={style}>
      <thead>
        <tr>
          {columns.map((col, i) => (
            <th style={{ width: `${100 / columns.length}%` }} key={i}>
              {col.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data?.length ? (
          data.map((row, i) => (
            <tr key={i}>
              {columns.map((col, k) => (
                <td key={k}>{row[col.field]}</td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={columns.length || 1}>Not specified</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

ApplicationFormTable.propTypes = {
  style: PropTypes.object,
  columnsNamesAndFields: PropTypes.object,
  data: PropTypes.arrayOf(PropTypes.object)
};
